import formAPITotalRevenueView from "./revenueView";

var formattedOutput = null;

const formapimodaltotalrevenueview = (data) => {
  // Apply formAPIModel to each item in the data array
  formattedOutput = data.map(item => formAPITotalRevenueView(item));


  return formattedOutput
};

export default formapimodaltotalrevenueview